module.exports = __webpack_public_path__ + "img/pic_310736_2.ef7f5d41.jpg";